import { Spinner } from "@carbon6/c6-frontend-design";
import type { MappingEditorState } from "../../../feature/mappingEditor";
import styles from "./MappingRefreshStatus.module.css";

/** 서버 저장본을 다시 확인하는 중인지와 그 실패. 바뀐 저장본은 편집 상태가 따르고 토스트로 알린다. */
export function MappingRefreshStatus({ state }: { state: MappingEditorState }) {
  return (
    <>
      {state.refreshing ? <Spinner size="sm" label="서버 매핑 확인 중" /> : null}
      {state.refreshError === null ? null : (
        <p className={styles.message} role="status">
          {state.refreshError} 편집본은 유지됩니다.
        </p>
      )}
    </>
  );
}
